import { getFunctions, httpsCallable } from "firebase/functions";
import { useQuery } from "react-query";

export type SupportedPingedCloudFunction = "updatePropertyInfoFields" | "updateTenantInfoFields" | "previewPostReceivers";

export const usePingedCloudFunction = (functionName: SupportedPingedCloudFunction) => {
  return useQuery(
    `pingedCloudFunction-${functionName}`,
    async () => {
      const firebaseFunctions = getFunctions(undefined, "europe-west1");
      const cloudFunction = httpsCallable(firebaseFunctions, functionName);
      return cloudFunction({
        ping: true,
      }).then(() => {
        console.log(`Successfully pinged cloud function: ${functionName}`);
        return true;
      });
    },
    { refetchInterval: 1000 * 60 * 10 }
  );
};

